<template lang="pug">
div.main(:class="this.template")
  navigation
  div.page(class="child product" :class="!product.active ? 'inactive' : 'active'")
    section#productInfo.row
      //- div.hero
        //- <img :src='null' alt='' //>
      meta-list(id="courseStructure-normal" :items="this.product.metaList" :product="this.product")

      article.productMain
        h1.title
          vue-markdown(:source='this.product.title')
        div.info
          span.price
            vue-markdown(:source='"€ " + this.product.price')
          //- span.category
          //-   vue-markdown(:source='this.product.category')
        div.desc
          vue-markdown(:source='this.product.body || this.product.description')

    meta-list.row(id="courseStructure-mobile" :items="this.product.metaList" :product="this.product")

    section(v-for="(n, i) in this.sections" class="row")
      component(:is="kebabToCamel(n.fields.templateId)" :payload="n")
    pageFooter
</template>

<script>
import pageBase from '@/scenes/_pageBase.js'
import metaList from '@/components/metaList'

export default {
  name: 'ProductScene',
  mixins: [pageBase],
  props: ['id'],
  components: {metaList},
  data: function () {
    return {
      product: this.$store.state.products[this.id] || {}
    }
  },
  created () {
    // console.log(this.sections);
  },
  mounted () {
  },
  methods: {
  },
  computed: {
  },
  watch: {
    'products': function (d) {
      this.product = d[this.id]
    }
  }
}

</script>

<style lang="scss">
// dirty quick fix
#courseStructure-normal{
  display: none;
  @include breakpoint(medium) {
    display: block;
  }
}
#courseStructure-mobile{
  display: none;
  @include breakpoint(small only) {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/scenes/productScene.vue